/** Sentinel value placed inside `mipIds` to filter for documents with no linked MIP. */
export const NO_MIP_FILTER_VALUE = 'NONE';
